import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/blogg/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/nyhet/$slug", params: { slug: params.slug }, statusCode: 301 });
  },
});
